import React, { useState, useEffect } from 'react';
import {
  TFolderPicture,
  TPicture
} from '../../../types/cloudStorage/CloudFileList';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
  addPicturesState,
  folderListState,
  selectedPicturesState
} from '../../../GlobalState';
import { getThumbnail } from '../../../apicalls/cloudFile';
import _ from 'lodash';
import { TLedgerPictur } from '../../../types/Ledger';

type TProps = {
  picture: TPicture;
  shooting_date: string;
  imageData: TLedgerPictur[] | undefined;
};

export const Image: React.FC<TProps> = (props: TProps) => {
  const { picture, shooting_date, imageData } = props;

  // 一括追加する写真達（左側に追加するために選択された写真達）
  const [addPictures, setAddPictures] =
    useRecoilState<TLedgerPictur[]>(addPicturesState);

  // 左の一覧で選択済みかのフラグ
  const [listSelectFlg, setListSelectFlg] = useState<boolean>(false);

  // 左の一覧に追加するための選択状態かのフラグ
  const [addSelectFlg, setAddSelectFlg] = useState<boolean>(false);

  // 写真のsrc
  const [src, setSrc] = useState<string>();

  useEffect(() => {
    if (!imageData) {
      return;
    }
    // 左の一覧に存在するかのチェック
    setListSelectFlg(
      imageData.some((item: TLedgerPictur) => item.picture_id == picture.id)
    );

    // サムネイル取得
    getThumbnail(picture.id).then(data => {
      if (data.data) {
        const image_data = data.data.replace(/^.*,/, '');
        setSrc(`data:${data.file_format};base64,${image_data}`);
      }
    });

    // 選択状態
    setAddSelectFlg(addPictures.findIndex(item => item.id == picture.id) != -1);
  }, [imageData]);

  const onClickImg = () => {
    const addData: TLedgerPictur[] = _.cloneDeep(addPictures);
    const index = addData.findIndex(item => item.picture_id == picture.id);
    if (index == -1) {
      addData.push({
        picture_id: picture.id,
        sort_order: 0,
        shooting_date: picture.shooting_date,
        place: '',
        note: picture.description
      });
      setAddSelectFlg(true);
    } else {
      addData.splice(index, 1);
      setAddSelectFlg(false);
    }
    setAddPictures(addData);
  };

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      {listSelectFlg ? (
        <div
          style={{
            zIndex: 10,
            color: 'white',
            position: 'absolute',
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,.6)',
            textAlign: 'center'
          }}
        >
          選択中
        </div>
      ) : (
        <div
          style={{
            zIndex: 10,
            color: 'white',
            position: 'absolute',
            width: '100%',
            height: '100%',
            backgroundColor: addSelectFlg ? 'rgba(0,0,0,.6)' : '',
            textAlign: 'center'
          }}
          onClick={onClickImg}
        >
          {addSelectFlg ? '追加' : ''}
        </div>
      )}
      {src ? (
        <img
          src={src}
          alt={shooting_date}
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      ) : (
        <div
          style={{
            backgroundColor: 'rgba(0,0,0,.6)',
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }}
        ></div>
      )}
    </div>
  );
};
